<template>
  <!-- 班级风采 -->
  <div class="inside_pages_right">
    <div class="row inside_pages_right_top">
      <div class="col-sm-12 inside_header_title">
        班级风采
      </div>
    </div>
    <div class="inside_pages_right_content" v-if="listBox == true">
      <div class="inside_pages_right_content_top">
        <div class="inside_pages_right_content_top_left ">
          <el-button
            type="primary"
            plain
            size="mini"
            icon="el-icon-circle-plus-outline"
            @click="openAddBox"
            >新增班级风采</el-button
          >
        </div>
      </div>
      <div class="inside_pages_right_content_center">
        <el-table
          :data="responseData.list"
          height="100%"
          border
          style="width: 100%"
        >
          <el-table-column prop="id" label="序号" width="80">
            <template slot-scope="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column prop="classCoverImage" label="图片" width="102">
            <template slot-scope="rowData">
              <el-image
                style="height:80px;width:80px"
                :src="
                  $store.state.config.fileUrl + rowData.row.classCoverImage
                "
                :preview-src-list="[
                  $store.state.config.fileUrl + rowData.row.classCoverImage,
                ]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="headline" show-overflow-tooltip label="标题">
          </el-table-column>
          <el-table-column prop="addContent" show-overflow-tooltip label="内容">
          </el-table-column>
          <el-table-column label="创建时间" width="200">
            <template slot-scope="rowData">
              {{ $Common.dateFormatDateTwo(rowData.row.addtime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="rowData">
              <!-- <el-button type="primary" plain size="mini" @click="openEditBox(rowData.row)">编辑</el-button> -->
              <el-button
                type="danger"
                plain
                size="mini"
                @click="delData(rowData.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="inside_pages_right_content_bottom">
        <div class="block">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="requestData.pageNum"
            :page-sizes="[20, 30, 50, 100]"
            :page-size="requestData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="responseData.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增校园动态 -->
    <div class="inside_pages_right_content" v-if="addBox == true">
      <div class="inside_pages_right_content_center ninety_Box">
        <form class="form-horizontal">
          <div class="form-group">
            <label class="col-sm-2 control-label">标题 </label>
            <div class="col-sm-10">
              <input
                type="text"
                  style="width:80%"
                v-model="addData.headline"
                class="form-control"
                placeholder="请填写标题"
              />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-2 control-label">封面图片 </label>
            <div class="col-sm-10">
              <label for="img_file">
                <input
                  type="file"
                  id="img_file"
                  @change="imgUpload($event)"
                />
                <span class="btn btn-info btn-sm">
                  <i class="el-icon-circle-plus"></i>
                  添加文件
                </span>
              </label>
            </div>
          </div>
          <div class="form-group" v-show="addData.classCoverImage != ''">
            <div class="col-sm-offset-2 col-sm-2">
              <div>
                <span class="thumbnail">
                  <img
                    v-if="addData.classCoverImage"
                    :src="
                      $store.state.config.fileUrl + addData.classCoverImage
                    "
                    alt="..."
                  />
                </span>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">内容 </label>
            <div class="col-sm-10">
              <el-input
                style="width:80%"
                v-model="addData.addContent"
                placeholder="请填写内容"
                clearable
                type="textarea"
                autosize
              ></el-input>
              <!-- <VueUeditorWrap/> -->
              <!-- <VueUeditorWrap v-model="addData.addContent" ></VueUeditorWrap> -->
            </div>
          </div>
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-2 control-label"></label>
            <div class="col-sm-10">
              <el-button size="mini" type="primary" @click="addClassStyle"
                >确定添加</el-button
              >
              <el-button size="mini" @click="closeAddBox">返回</el-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  name: '',
  components: {
    VueUeditorWrap,
  },
  props: {},
  data() {
    return {
      listBox: true,
      addBox: false,
      requestData: {
        schoolId: this.$store.state.schoolId,
        pageSize: 20,
        pageNum: 1,
      },
      responseData: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
        pages: 0,
        list: [],
      },
      addData: {
        classCoverImage: '', // 封面图片
        addContent: '', // 内容详情
        headline: '', // 标题内容
        userId: this.$store.getters.getUserInfo.userId, // 用户ID
        schoolId: this.$store.state.schoolId,
      },
    }
  },
  watch: {},
  computed: {},
  methods: {
    handleSizeChange(val) {
      this.requestData.pageSize = val
      // console.log(`每页 ${val} 条`);
      this.getClassStyle()
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val
      // console.log(`当前页: ${val}`);
      this.getClassStyle()
    },
    // 班级风采
    async getClassStyle() {
      var newParamData = this.requestData
      let res = await this.$Http.getClassStyle(newParamData, true)
      if (res.code == 200) {
        this.responseData.pageSize = res.data.pageSize
        this.responseData.pageNum = res.data.pageNum
        this.responseData.total = res.data.total
        this.responseData.pages = res.data.pages
        this.responseData.list = res.data.list
        // console.log(res.data)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: 'error',
          message: res.messsage,
        })
      }
    },
    // 打开新增
    openAddBox() {
      this.listBox = false
      this.addBox = true
    },

    // 关闭新增
    closeAddBox() {
      this.listBox = true
      this.addBox = false
    },

    // 删除数据
    delData(dataId) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          var requestData = {
            id: dataId,
          }
          let res = await this.$Http.delClassStyle(requestData, true)
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.getClassStyle()
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: 'error',
              message: res.messsage,
            })
          }
        })
        .catch(() => {})
    },

    // 提交新增数据
    async addClassStyle() {
      var newParamData = this.addData
      let res = await this.$Http.addClassStyle(newParamData)
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.messsage,
        })
        this.addData.addContent = ''
        this.addData.classCoverImage = ''
        this.addData.headline = ''
        this.getClassStyle()
        this.closeAddBox()
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: 'error',
          message: res.messsage,
        })
      }
    },

    // 图片上传
    async imgUpload(event) {
      var uploadInfo = await this.$Common.fileUpload(event)
      if (uploadInfo) {
        this.addData.classCoverImage = uploadInfo.fileUrl
        // console.log(this.addData)
      }
    },
  },
  created() {},
  mounted() {
    this.getClassStyle()
  },
}
</script>
<style scoped></style>
